<!-- AccordionItem.vue -->
<template>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggle">
        <h3 class="title-item" >{{ title }}</h3>
        <i :class="isOpen ? 'icon-open' : 'icon-closed'"></i>
      </div>
      <transition name="accordion">
        <div v-if="isOpen" class="accordion-body">
          <slot></slot>
        </div>
      </transition>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        isOpen: false
      };
    },
    methods: {
      toggle() {
        this.isOpen = !this.isOpen;
      }
    }
  };
  </script>
  
  <style scoped>
  .accordion-item {
    border: 1px solid #ddd;
    margin-bottom: 10px;
    border-radius: 4px;
    overflow: hidden;
  }
  
  .accordion-header {
    background-color: #f7f7f7;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

  }

  h3{
    line-height: 1.2; 
    font-size: var(--mdb-body-font-size);
    font-family: 'Titillium Web';
    font-weight: 600;
    font-style: normal;
  }
  
  .accordion-body {
    padding: 15px;
    background-color: #fff;
    font-size: 0.90rem;
  }
  
  .icon-open::before {
    content: "−";
  }
  
  .icon-closed::before {
    content: "+";
  }
  
  .accordion-enter-active, .accordion-leave-active {
    transition: max-height 0.3s ease;
  }
  
  .accordion-enter, .accordion-leave-to {
    max-height: 0;
  }
  </style>
  